<template>
    <div class="all">
        <div class="container">
            <div class="grid h-auto">
                <div class="jianshu">
                    <h2><i class="tag" v-if="eventEmotion != ''" :class="$parent.attributeType[eventEmotion]">{{eventEmotion}}</i><span class="ml10">{{title}}</span></h2>
                    <p class="mt5">开始时间 {{beginDate}}</p>
                    <p class="mt5 color-8a8a99">{{description}}</p>
                    <div class="img ac">
                        <img :src="ewmUrl"/>
                        <span class="db">打开手机扫一扫</span>
                    </div>
                </div>
                <div class="grid-header mt30 clearfix">
                    <h2 class="title">事件概况</h2>
                </div>
                <div class="grid-body mt15" v-html="hotOver">{{hotOver}}</div>
            </div>
            <div class="grid h-auto mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">事件走势</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h305">
                        <lineChart id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" :isShowArea="false" gridBot ="60"></lineChart>
                        <div class="no-data" v-if="nodata.hotEventData"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="grid h-auto mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">媒体分析</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h305">
                        <pieChart id="media" :dataArray="mediaData" v-if="mediaData != ''" :colorArr="mediaColorArr"></pieChart>
                        <div class="no-data" v-if="nodata.mediaData"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>

            <div class="grid h-auto mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">活跃账号</h2>
                </div>
                <div class="grid-body mt20">
                    <div class="corm clearfix">
                        <span class="element" v-for="(item,index) in activeAccTab" :key="index" @click="choseAccout(index)" :class="{'curr':curIndex == index}">{{item}}</span>
                    </div>
                    <ul class="strip-shape clearfix two">
                        <li v-for="(item,index) in activeAccList" :key="index">
                            <div class="people clearfix fl">
                                <img :src="item.icon == '' ? $parent.baseUrl+'/static/images/head_img.png' : item.icon" class="img fl"/>
                                <span class="name ovhidden" :title="item.name">{{item.name}}</span>
                            </div>
                            <div class="number fr">
                                <span class="color-blue">{{item.value}}</span>篇
                            </div>
                            <div class="line-warp clearfix">
                                <div class="line">
                                    <div class="in" :style='{width:""+item.percent+""}'></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data" v-if="nodata.activeAccList"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>

            <div class="grid h-auto mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">微博分析</h2>
                </div>
                <div class="grid-body mt15">
                    <div>
                        <p class="mt5">事件在微博传播过程中，共分析到微博<strong class="color-blue">{{wbAnalysisHtml.articleCount}}</strong>条，微博传播受众<strong class="color-blue">{{wbAnalysisHtml.followersCount}}</strong>人。</p>
                        <p class="mt5">
                            其中<span  v-for="(item,index) in wbAnalysisHtml.descHtml" :key="index">{{index}}微博受众<strong class="color-blue">{{item}}</strong>人、</span>
                        <p class="mt5">本次事件<strong class="color-blue">{{wbAnalysisHtml.effectMaxType}}</strong>影响力最大</p>
                    </div>
                    <div class="echart-warp h305">
                        <span class="wbShow">参与/辐射人群</span>
                        <eventBarChart id="barEchart" :dataArray="wbAnalysisData" v-if="wbAnalysisData != ''" ></eventBarChart>    
                    </div>
                    
                </div>
            </div>

            <div class="grid h-auto mt20">
                <div class="grid-header clearfix">
                    <h2 class="title fl">影响力博主</h2>
                    <div class="corm fr clearfix">
                        <span class="element" :class="{'curr':curWbType==item}" @click="wbTypeChose(item)" v-for="(item,index) in wbTypeList" :key="index">{{item}}</span>
                    </div>
                </div>
                <div class="grid-body mt30">
                   <div class="patch-warp clearfix">
                        <div class="imgText patch clearfix" v-for="(item,index) in bloggerList" :key="index">
                            <img :src="item.mediaPic==''?$parent.baseUrl+'/static/images/head_img.png':item.mediaPic" class="img fl"/>
                            <div class="hidden">
                                <div class="clearfix">
                                    <h3>{{item.mediaName}}</h3>
                                    <p class="ziduan">
                                        <span>受众人数：<strong class="color-blue">{{item.followersCount}}</strong></span>
                                        <span>相关微博数：<strong class="color-blue">{{item.relationNum}}</strong></span>
                                    </p>
                                </div>
                                <p class="mt10 color-8a8a99 ovhidden2" :title="item.originNewsDigest">{{item.newsDigest}}</p>
                            </div>
                        </div>
                        <div class="no-data" v-if="nodata.bloggerList"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                   </div>
                </div>
            </div>

            <div class="echart-grid clearfix">
                <div class="grid-father">
                    <div class="grid">
                        <div class="grid-header clearfix">
                            <h2 class="title fl">情感属性</h2>
                            <div class="corm fr clearfix">
                                <span class="element" :class="tuType === 'line' ? 'curr' : ''" @click="emotionEchartTab('line');">趋势图</span>
                                <span class="element" :class="tuType === 'pie' ? 'curr' : ''" @click="emotionEchartTab('pie');">饼状图</span>
                            </div>
                        </div>
                        <div class="grid-body mt15">
                            <div class="echart-warp h305" >
                                <div class="no-data" v-if="tuType === 'pie' && nodata.emotionData2"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                                <lineChart id="emotion1" :dataArray="emotionData1" v-if="tuType === 'line' && emotionData1 != ''"></lineChart>
                                <pieChart id="pieEchart1" :dataArray="emotionData2" :colorArr="emotionColorArr" v-if="tuType === 'pie' && emotionData2 != ''"></pieChart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-father">
                    <div class="grid">
                        <div class="grid-header clearfix">
                            <h2 class="title fl">热门主题词</h2>
                            <div class="collection fr clearfix">
                                <span class="tion drop-down">
                                    <button class="btn btn-lightblue">{{curHotTheme}}<i class="icons"></i></button>
                                    <ul class="option">
                                        <li @click="hotThemeTab(index);" v-for="(item,index) of mtType" :key="index">{{item}}</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                        <div class="grid-body mt15">
                            <div class="echart-warp h305">
                                <div class="no-data" v-if="nodata.defaultWords"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                                <cloudChart id="wordCloud" :dataArray="defaultWords" v-if="hotThemeType == 0 && defaultWords!= ''"></cloudChart>
                                <pieChart v-if="hotThemeType == 1 && hotThemePie != ''" id="pieEchart3" :dataArray="hotThemePie" :showLegend="false"></pieChart>
                                <radarChart v-if="hotThemeType == 2 && hotThemeRadar != ''" id="radarEchart" :dataArray="hotThemeRadar"></radarChart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-father">
                    <div class="grid">
                        <div class="grid-header clearfix">
                            <h2 class="title fl">发布地区</h2>
                            <div class="collection fr clearfix">
                                <span class="drop-down mores">
                                    <button class="btn btn-lightblue">{{curPublishArea}}<i class="icons"></i></button>
                                    <ul class="option pl">
                                        <li v-for="(item,index) in areaChoseList" :key="index" @click="changeArea(item,1)">{{item}}</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                        <div class="grid-body mt15">
							<div class="no-data data-load" v-if="load.mapChartData"><img :src="$parent.baseUrl+'/static/images/loading1.gif'" class="img"/><span class="text">获取数据中...</span></div>
                            <div class="clearfix" v-if="!load.mapChartData">
                                <div class="region mt20 fl">
                                    <div class="region-header">
                                        <span class="span fl">地区</span>
                                        <span class="span fl">数量</span>
                                    </div>
                                    <div class="region-body">
                                        <vue-scroll :ops="ops" style="width:160px;height:246px">
                                            <div class="item" v-for="(item,index) in publishAreaData" :key="index">
                                                <span class="span fl">{{item.name}}</span>
                                                <span class="span fl">{{item.value}}</span>
                                            </div>
                                        </vue-scroll>
                                    </div>
                                </div>
                                <div class="echart-warp hidden h305">
                                    <mapChart id="publishArea" :dataArray="publishAreaData" :areaName="curPublishArea" v-if="publishAreaData != ''"></mapChart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-father">
                    <div class="grid">
                        <div class="grid-header clearfix">
                            <h2 class="title fl">提及地区</h2>
                            <div class="collection fr clearfix">
                                 <span class="drop-down mores">
                                    <button class="btn btn-lightblue">{{curMentionArea === 'top' ? '全国' : curMentionArea}}<i class="icons"></i></button>
                                    <ul class="option pl">
                                        <li v-for="(item,index) in areaChoseList" :key="index" @click="changeArea(item,2)">{{item}}</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                        <div class="grid-body mt15">
							<div class="no-data data-load" v-if="load.mapChartData1"><img :src="$parent.baseUrl+'/static/images/loading1.gif'" class="img"/><span class="text">获取数据中...</span></div>
                            <div class="clearfix" v-if="!load.mapChartData1">
                                <div class="region mt20 fl">
                                    <div class="region-header">
                                        <span class="span fl">地区</span>
                                        <span class="span fl">数量</span>
                                    </div>
                                    <div class="region-body">
                                        <vue-scroll :ops="ops" style="width:160px;height:246px">
                                            <div class="item" v-for="(item,index) in mentionAreaData" :key="index">
                                                <span class="span fl">{{item.name}}</span>
                                                <span class="span fl">{{item.value}}</span>
                                            </div>
                                        </vue-scroll>
                                    </div>
                                </div>
                                <div class="echart-warp hidden h305">
                                    <mapChart id="mentionArea" :dataArray="mentionAreaData" :areaName="curMentionArea" v-if="mentionAreaData != ''" ></mapChart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="grid h-auto mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">主流媒体</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="eventBox">
                        <div class="eventChannel clearfix" ref="eventChan" @mousedown="start">
                            <dl class="eventChannel-dl fl h305" v-for="(item,index) in eventList" :key="index">
                                <dd class="ac">
                                    <p  v-for="(item1,index1) in item.event" :key="index1" v-if="item1.name!=''">
                                        <span class="eventChannelText" :class="'ovhidden ec'+(index1+1)" :title="item1.name">{{item1.name}}</span>
                                        <label class="eventChannelTit hide"><a class="ovhidden" :title="item1.decription">{{item1.decription}}</a></label>
                                    </p>
                                </dd>
                                <dt><span>{{item.dataTime}}</span></dt>
                            </dl>
                        </div>
                        <div class="no-data" v-if="nodata.eventChan"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div> -->
        </div>
	</div>
</template>
<script>
import lineChart from '../../components/echart/lineChart.vue';
import pieChart from '../../components/echart/pieChart.vue';
import radarChart from '../../components/echart/radarChart.vue';
import eventBarChart from '../../components/echart/eventBarChart.vue';
import mapChart from '../../components/echart/mapChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
//import wordcloud from 'vue-wordcloud';
export default {
    data() {
        return {
            ewmUrl:'http://qr.topscan.com/api.php?m=0&text=https://m.gsdata.cn/events/event-'+this.$route.query.id+'',//二维码地址
            sid : this.$route.query.id,
            title:'',
            beginDate:'',
            
            description:'',
            hotOver:'',
            hotEventData:[],//事件走势
            mediaData:[],//媒体分析
            mediaColorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            colorArr:["#56566a","#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            curIndex:'total',
            activeAccTab:[],
			allActiveAccList:[],//所有平台的活跃账号数据
            activeAccList:[],
            wbAnalysisHtml:{},//微博分析html
            wbAnalysisData:[],//微博分析
            curWbType:'个人认证',
            wbTypeList:[],
            bloggerAllList:[],
            bloggerList:[],//影响力博主
            emotionData1:[],//情感属性折线
            emotionData2:[],//情感属性饼图
            eventEmotion:[],//头部情感属性标签显示
            tuType:'pie',//控制图表类型
            emotionColorArr:['#0095eb','#ff8121','#e63349'],
            mtType:['词云图','饼图','雷达图'],//媒体类别
            defaultWords:[],//热门主题词词云图
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            curHotTheme:'词云图',
            hotThemePie:[],//热门主题词饼图
            hotThemeRadar:[],
            hotThemeType:0,
            publishAreaData:[],//发布地区
            areaChoseList:[],
            curPublishArea:'全国',
            mentionAreaData:[],//提及地区
            // isShowMap:true,
            // isShowMention:false,
            curMentionArea:'top',
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            //eventList:[], //重要渠道
            // isShowDec:null,//是否显示浮框
            // isShowDec1:null,//是否显示浮框
            gapX:0,
            startx:0,
            endx:0,
            nodata:{
                emotionData2:false,
                defaultWords:false,
                hotEventData:false,
                mediaData:false,
                activeAccList:false,
                bloggerList:false,
                //eventChan:false
            },
			load:{
                'mapChartData':false,
                'mapChartData1':false
            }
        }
    },
    components:{
        lineChart,pieChart,radarChart,eventBarChart,cloudChart,mapChart
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
			that.allDataAjax();
            // that.dataAjax();
            // that.bloggerAjax();
            // that.activeAccAjax();
            // that.hotThemeAjax();
            that.publishAreaAjax();
            that.mentionAreaAjax();
        })
    },
    methods: {
		allDataAjax (){
			let that = this;
			that.$parent.loadModal(true,'正在获取数据...');
			that.$api.get('hotnews/hot-news/data-info',{sid:that.sid},r =>{
				that.$parent.showLoad = false;
				let data = r.data;
				let detail = data.detail;
				that.title = data.name;
				that.beginDate = data.beginTime;
				that.description = data.schemeDescription;
				that.hotOver = detail.summary;
				that.hotEventData = detail.eventTrend;
				that.mediaData = detail.mediaAnalysis;
				that.activeAccTab = detail.activeAccount.platform;
				that.allActiveAccList = detail.activeAccount.data;
				that.choseAccout('total');
				that.wbAnalysisHtml = detail.weiboAnalysis;
				// 微博分析柱状图数据
				let wbData = {};
				wbData.datetime = detail.weiboAnalysis.keyList;
				wbData.dataName = ['辐射人群','参与数量'];
				wbData.data=[];
				wbData.data.push(detail.weiboAnalysis.followersNumList);
				wbData.data.push(detail.weiboAnalysis.articleNumList);
				that.wbAnalysisData = wbData;
				// 微博分析柱状图数据结束
				// 影响力博主
				detail.influenceBo.forEach((ele,index)=>{
				    that.wbTypeList.push(ele.name);
				    that.bloggerAllList[ele.name] = ele.newsList;
				    if(index===0){
				        that.wbTypeChose(ele.name);
				    }
				});
				// 影响力博主结束
				that.emotionData2 = detail.emotion;
				that.emotionData1 = detail.emotionLine;
                that.eventEmotion = data.emotion;
				that.defaultWords = detail.hotword;
				that.hotThemePie = detail.hotword.slice(0,20);
				that.hotThemeRadar = detail.hotword.slice(0,20);
				// that.areaChoseList
				if(that.hotEventData <= 0){//判断热点事件暂无数据
				    that.nodata.hotEventData = true;
				}
				if(that.mediaData <= 0){
				    that.nodata.mediaData = true;
				}
				if(that.emotionData2<=0){
				    that.nodata.emotionData2 = true;
				}
				if(that.defaultWords <= 0){
				    that.nodata.defaultWords = true;
				}
			})
		},
        //影响力博主
        wbTypeChose(name){
            let that = this;
            that.curWbType = name;
            that.bloggerList = that.bloggerAllList[name];
			if(that.bloggerList <= 0){
			    that.nodata.bloggerList = true;
			}else{
				that.nodata.bloggerList = false;
			}
        },
        // 情感属性图表切换
        emotionEchartTab(type) {
            this.tuType = type;
        },
        //活跃账号切换
        choseAccout(num){
            this.curIndex = num;
            this.activeAccList = this.allActiveAccList[num];
			if(this.activeAccList <= 0){
			    this.nodata.activeAccList = true;
			}else{
				this.nodata.activeAccList = false;
			}
        },
        wordClickHandler(name, value, vm) {
            // console.log('wordClickHandler', name, value, vm);
        },
        // 热门主题词切换
        hotThemeTab (type) {
            this.hotThemeType = type;
            this.curHotTheme = this.mtType[type];
        },
        // 发布地区
        getAreaType(data){
            let that = this;
            if(that.curPublishArea ==="全国" && that.areaChoseList.length===0){
                //that.curMentionArea = data[0].name;               
                data.forEach(ele => {
                    that.areaChoseList.push(ele.name);
                });
                that.areaChoseList.unshift("全国");
            }
        },
        publishAreaAjax(){
            let that = this;
            let dataArgs = {sid:that.sid};
            if(that.curPublishArea!="全国"){
                dataArgs.province = that.curPublishArea
            }
            that.$api.get('hotnews/hot-news/publish-area',dataArgs,r=>{
                that.$parent.returnCode(r,function(){
					that.load.mapChartData = false;
                    // that.publishAreaData = [];
                    // that.isShowMap = true;
                    // r.data.forEach((ele,index)=>{
                    //     if(ele.value == 0 && (index ==0)){
                    //         ele.value = '-';
                    //         that.publishAreaData.push(ele)
                    //         that.isShowMap = false;
                    //     }if(ele.value != 0){
                    //         that.publishAreaData.push(ele)
                    //     }
                    // });
                    that.publishAreaData = r.data;
                    that.getAreaType(r.data)
                });
            });
        },
        //提及地区
        mentionAreaAjax(){
            let that = this;
            let dataArgs = {sid:that.sid};
            if(that.curMentionArea!="全国"){
                dataArgs.province = that.curMentionArea
            }
            that.$api.get('hotnews/hot-news/mention-area',dataArgs,r=>{
                that.$parent.returnCode(r,function(){
                    that.mentionAreaData = r.data.data;
					that.load.mapChartData1 = false;
                    // that.mentionAreaData = [];
                    // that.isShowMention = true;
                    // r.data.data.forEach((ele,index)=>{
                    //     if(ele.value == 0 && (index ==0)){
                    //         ele.value = '-';
                    //         that.mentionAreaData.push(ele)
                    //         that.isShowMention = false;
                    //     }else if(ele.value != 0){
                    //         that.mentionAreaData.push(ele)
                    //     }
                    // });
                    that.curMentionArea = r.data.topProvince;
                    that.getAreaType(r.data.data)
                });
            });
        },
        changeArea(name,type){
            let that = this;
            if(type==1){
				that.load.mapChartData = true;
                that.curPublishArea = name;
                that.publishAreaAjax();
            }else{
				that.load.mapChartData1 = true;
                that.curMentionArea = name;
                that.mentionAreaAjax();
            }
            
        },
        fatherMethod(name,id){
            let that = this;
            if(id=="publishArea"){
                that.changeArea(name,1)
            }else{
                that.changeArea(name,2)
            }
        },
        //重要渠道拖动
        // start(event){
        //     let that = this;
        //     if($(".eventChannel").width() < $(".eventBox").width()){
        //         return false;
        //     }  
        //     if(event.button==0){//判断是否点击鼠标左键  
        //         that.gapX=event.screenX;
        //         that.startx = that.endx;  // scroll的初始位置
        //         $(".eventBox").bind("mousemove",that.move);  
        //         $(document).bind("mouseup",that.stop);                           
        //     }  
        //     return false;//阻止默认事件或冒泡  
        // },  
        // move(event){  
        //     let that = this;
        //     this.isShowDec = null;
        //     this.isShowDec1 = null;  
        //     var moveX = event.clientX-that.gapX; // 鼠标移动的相对距离
        //     if(that.endx>=($(".eventChannel").width()-$(".eventBox").width())&& moveX<0){
        //         return false;
        //     } 
        //     if(that.endx < 0 && moveX>0){
        //         return false;
        //     }
        //     that.endx = that.startx;//当前的scrollLeft值
        //     that.endx -= moveX; 
        //     $(".eventBox").scrollLeft(that.endx) ;
        //     return false;//阻止默认事件或冒泡  
        // },  
        // stop(){ 
        //     let that = this;   
        //     $(".eventBox").unbind("mousemove",that.move);  
        //     $(document).unbind("mouseup",that.stop);  
        // }  
	}
}
</script>
<style scoped>
    .echart-warp{position: relative;}
</style>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/eventDetail.vue